import { CommonModule } from '@angular/common';
import {
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { BrandedWistiaComponent } from '@shared/wistia/branded-wistia/branded-wistia.component';
import { ViewerBaseComponent } from '../viewer-shared/viewer-base.component';
import { ViewerService } from '../viewer.service';

@Component({
  selector: 'zbp-viewer-video',
  templateUrl: './viewer-video.component.html',
  styleUrls: ['./viewer-video.component.scss',
    '../viewer.component.scss'
  ],
  encapsulation: ViewEncapsulation.None,
  providers: [ViewerService],
  imports: [CommonModule, BrandedWistiaComponent]
})
export class ViewerVideoComponent extends ViewerBaseComponent implements OnChanges, OnDestroy {
  componentRef: any;
  videoWidth: number = 1;
  videoHeight: number = 1;

  @Output() videoDimensions: EventEmitter<{ width: number, height: number }> = new EventEmitter();

  @ViewChild('wistiaContainer', { read: ViewContainerRef }) wistiaContainer: ViewContainerRef;

  constructor(
    private resolver: ComponentFactoryResolver
  ) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.asset?.currentValue?.assetId
      && changes.asset?.currentValue?.assetId !== changes.asset?.previousValue?.assetId) {
      this.replaceWistiaComponent();
    }
  }

  /** Removes the existing wistia component and creates a new one with the new assetID */
  replaceWistiaComponent() {
    if (!this.wistiaContainer || !this.asset.fileName) {
      return;
    }

    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }

    // Clear the container
    this.wistiaContainer.clear();

    const factory = this.resolver.resolveComponentFactory(BrandedWistiaComponent);
    this.componentRef = this.wistiaContainer.createComponent(factory);
    const brandedWistiaComponent: BrandedWistiaComponent = this.componentRef.instance;

    brandedWistiaComponent.wistiaCode = this.asset.fileName;
    brandedWistiaComponent.isViewerFullScreen = false;
    brandedWistiaComponent.isViewer = true;

    brandedWistiaComponent.videoReady.subscribe(() => this.setLoaded());
    brandedWistiaComponent.videoError.subscribe(() => this.setError());
    brandedWistiaComponent.videoEnded.subscribe(() => this.setComplete());
  }

  setLoaded(): void {
    this.loaded.emit();
  }

  setError(): void {
    this.withError.emit('Unable to load video');
  }

  setComplete(): void {
    this.completed.emit();
  }

  ngOnDestroy(): void {
    this.componentRef?.destroy();
  }

  loadVideoDimensions(dimensions: { width: number, height: number }): void {
    this.videoWidth = dimensions.width;
    this.videoHeight = dimensions.height;
    this.videoDimensions.emit(dimensions);
  }
}
